export const    ROOM = 'ROOM';
export const    ROOM_SUCCESS = 'ROOM_SUCCESS';
export const    ROOM_ERROR = 'ROOM_ERROR';

export const    ADD_ROOM = 'ADD_ROOM';
export const    ADD_ROOM_SUCCESS = 'ADD_ROOM_SUCCESS';
export const    ADD_ROOM_ERROR = 'ADD_ROOM_ERROR';

export const    UPDATE_ROOM = 'UPDATE_ROOM';
export const    UPDATE_ROOM_SUCCESS = 'UPDATE_ROOM_SUCCESS';
export const    UPDATE_ROOM_ERROR = 'UPDATE_ROOM_ERROR';

export const DELETE_ROOM = 'DELETE_ROOM';
export const DELETE_ROOM_SUCCESS= 'DELETE_ROOM_SUCCESS';
export const DELETE_ROOM_ERROR ='DELETE_ROOM_ERROR';


export const ROOM_ITEM = 'ROOM_ITEM';
export const ROOM_ITEM_SUCCESS = 'ROOM_ITEM_SUCCESS';
export const ROOM_ITEM_ERROR = 'ROOM_ITEM_ERROR';

export const ADD_ROOM_ITEM = 'ADD_ROOM_ITEM';
export const ADD_ROOM_ITEM_SUCCESS = 'ADD_ROOM_ITEM_SUCCESS';
export const ADD_ROOM_ITEM_ERROR = 'ADD_ROOM_ITEM_ERROR';

export const UPDATE_ROOM_ITEM = 'UPDATE_ROOM_ITEM';
export const UPDATE_ROOM_ITEM_SUCCESS = 'UPDATE_ROOM_ITEM_SUCCESS';
export const UPDATE_ROOM_ITEM_ERROR = 'UPDATE_ROOM_ITEM_ERROR';

